import { useCallback, useState } from 'react';
import { readString, writeString } from '../lib/storage';

export type Theme = 'dark' | 'light';

/** Light is the default; an explicit choice is remembered in localStorage (per browser and site). */
const current = (): Theme => (document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light');

export function useTheme() {
  const [theme, setThemeState] = useState<Theme>(() => (readString('mona.theme') === 'dark' ? 'dark' : readString('mona.theme') === 'light' ? 'light' : current()));
  const toggle = useCallback(() => {
    const next: Theme = current() === 'dark' ? 'light' : 'dark';
    document.documentElement.setAttribute('data-theme', next);
    writeString('mona.theme', next);
    setThemeState(next);
  }, []);
  return { theme, toggle };
}
